const LoaderSmallLightGreen = () => {
  return (
    <div className="loader-container" id="loader">
      <div className="lds-dual-ring-light-green"></div>
    </div>
  );
};

export default LoaderSmallLightGreen;
